import { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import "./AnimatedGifText.css";

const AnimatedGifText = ({
  textArray,
  speed = 1000,
  resetDelay = 1000,
  pauseDuration = 150,
}) => {
  const [currentIndex, setCurrentIndex] = useState(-1);

  useEffect(() => {
    if (currentIndex >= textArray.length) {
      const resetTimer = setTimeout(() => {
        setCurrentIndex(-1);
      }, resetDelay);
      return () => clearTimeout(resetTimer);
    }

    const delay =
      textArray[currentIndex]?.includes(" ") && pauseDuration > speed
        ? pauseDuration
        : speed;

    const timer = setTimeout(() => {
      setCurrentIndex((prev) => prev + 1);
    }, delay);

    return () => clearTimeout(timer);
  }, [currentIndex, textArray.length, speed, resetDelay, pauseDuration]);

  return (
    <Typography className="animated-gif-text">
      {textArray.map((char, index) => (
        <Box
          key={index}
          className="gif-text"
          sx={{
            color: index <= currentIndex ? "#A2C357" : "#6E6E6E",
            mx: char === " " ? "4px" : "0px",
          }}
        >
          {char}
        </Box>
      ))}
    </Typography>
  );
};

export default AnimatedGifText;
